export default __webpack_public_path__ + "static/media/play.5f4cc22d.svg";